import { IAutoRecoveryConfiguration } from '../../../FrontApplet/Management/AutoRecovery/IAutoRecovery';
import { EmptyObject } from '../../EmptyObject';

export type ManagementAutoRecoveryRequests = ManagementAutoRecoveryGetRequest | ManagementAutoRecoverySetRequest;

export const ManagementAutoRecoveryGetRequest = 'sos.Monitoring.Management.ManagementAutoRecoveryGetRequest';
export interface ManagementAutoRecoveryGetRequest {
	type: typeof ManagementAutoRecoveryGetRequest;
}

export const ManagementAutoRecoveryGetResult = 'sos.Monitoring.Management.ManagementAutoRecoveryGetResult';
export interface ManagementAutoRecoveryGetResult {
	type: typeof ManagementAutoRecoveryGetResult;
	result: IAutoRecoveryConfiguration;
}

export const ManagementAutoRecoverySetRequest = 'sos.Monitoring.Management.ManagementAutoRecoverySetRequest';
export interface ManagementAutoRecoverySetRequest {
	type: typeof ManagementAutoRecoverySetRequest;
	configuration: IAutoRecoveryConfiguration;
}

export const ManagementAutoRecoverySetResult = 'sos.Monitoring.Management.ManagementAutoRecoverySetResult';
export interface ManagementAutoRecoverySetResult {
	type: typeof ManagementAutoRecoverySetResult;
	result: EmptyObject;
}
